import { jsx as _jsx } from "react/jsx-runtime";
import { penal } from '@academia-apolo/shared-content';
import { LawCodePage } from './LawCodePage';
/** Código Penal (LO 10/1995, consolidado) — generic law viewer filtered by libro. */
export function PenalCodePage() {
    return (_jsx(LawCodePage, { data: penal, filterLevel: "libro", searchPlaceholder: "Buscar por n\u00FAmero, palabra o frase (p. ej. '138', 'homicidio', 'pena de prisi\u00F3n')\u2026" }));
}
//# sourceMappingURL=PenalCodePage.js.map